import React from 'react';
import { Link } from 'react-router-dom';
import { Dropdown } from "react-bootstrap";

const UserMenu = () => {

    // loggedin user data
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
    const token = localStorage.getItem('token') || '';


    return (
      
            <Dropdown className='no-shadow'>
                <Dropdown.Toggle
                    as="div"
                    bsPrefix="custom-toggle"
                    className="nav-link p-0 h4 fw-semibold d-flex align-items-center gap-2 mb-0"
                >
                    <div className="avatar rounded-circle overflow-hidden">
                        <img
                            src={`${process.env.PUBLIC_URL}/assets/img/user.png`}
                            alt="Maria"
                            className="w-50 h-50object-fit-cover object-center"
                        />
                    </div>
                </Dropdown.Toggle>
                <Dropdown.Menu className="dropdown-menu-end no-shadow wide-dropdown">

                    <Dropdown.Item as="div" className="gradient-light p-3 mb-2">
                        <div className="d-flex align-items-center justify-content-between gap-2">
                            <div className="profile d-flex align-items-center gap-2">
                                <div className="avatar">
                                    <img
                                        src={`${process.env.PUBLIC_URL}/assets/img/user.png`}
                                        alt="Marial K Paul"
                                        className="w-50 h-50 object-fit-cover object-center"
                                    />
                                </div>
                                <p>{userInfo.name} {' '} {userInfo.surname}</p>
                            </div>
                            <Link
                                to="/logout"
                                className="logout bg-primary text-white d-flex align-items-center justify-content-center rounded-5"
                            >
                                <span className="d-block material-symbols-outlined">logout</span>
                            </Link>
                        </div>
                    </Dropdown.Item>
                    <Dropdown.Item as={Link} to="/dashboard" className="d-flex align-items-center gap-3 text-black">
                        <span className="d-block material-symbols-outlined">space_dashboard</span>
                        <span className="d-block">Dashboard</span>
                    </Dropdown.Item>
                    <Dropdown.Item as={Link} to="/conversation" className="d-flex align-items-center gap-3 text-black">
                        <span className="d-block material-symbols-outlined">forum</span>
                        <span className="d-block">Conversation</span>
                    </Dropdown.Item>
                    
                </Dropdown.Menu>
            </Dropdown>
    
    );
};

export default UserMenu;
